import { render, staticRenderFns } from "./listApp.vue?vue&type=template&id=1bd78aa6&scoped=true&"
import script from "./listApp.vue?vue&type=script&lang=js&"
export * from "./listApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd78aa6",
  null
  
)

export default component.exports